import React, { useEffect, useRef } from "react";
import {getLoginRedirectTarget, LoginForm} from "@/components/Forms/Login/LoginForm";
import CardContent from "@mui/material/CardContent";
import Head from "next/head";
import {AppBarLayout} from "@/layouts/AppBarLayout";
import Box from "@mui/material/Box";
import { Card, Container, Grid, useMediaQuery, useTheme } from "@mui/material";
import { useRouter } from "next/router";
import { useAuth } from "@/hooks/auth";

export default function LoginPage() {
  const router = useRouter();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isDarkMode = theme.palette.mode === 'dark';
  const redirectUrl = router.query.redirect_url;
  const { currentUser, loading } = useAuth();
  const hasRedirected = useRef(false);

  useEffect(() => {
    if (!router.isReady || loading || !currentUser || hasRedirected.current) return;

    hasRedirected.current = true;
    window.location.replace(getLoginRedirectTarget(redirectUrl));
  }, [currentUser, loading, redirectUrl, router.isReady]);

  return (
    <>
      <Head>
        <title>Login</title>
      </Head>

      <AppBarLayout publicAllowed>
        <Box style={{ height: 'calc(100vh - 64px)', backgroundColor: theme.palette.background.default, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Container maxWidth="md" style={{ padding: '2rem' }}>
            <Card style={{ maxWidth: '800px', margin: '0 auto', overflow: 'hidden' }}>
              <CardContent style={{ padding: 0 }}>
                <Grid container>
                  {/* Top Image for Mobile/Tablet */}
                  {isMobile && (
                    <Grid item xs={12} style={{
                      backgroundColor: isDarkMode ? '#000000' : 'transparent',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: '2rem'
                    }}>
                      <img
                        src="/img/PDS-Cultivation-Intelligence.png"
                        alt="PDS Cultivation Intelligence"
                        style={{
                          maxWidth: '100%',
                          height: 'auto',
                          width: 'auto'
                        }}
                      />
                    </Grid>
                  )}
                  
                  {/* Image Side for Desktop */}
                  {!isMobile && (
                    <Grid item md={6} style={{ 
                      backgroundColor: isDarkMode ? '#000000' : '#fafafa',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: 0
                    }}>
                      <img
                        src="/img/PDS-Cultivation-Intelligence-vertical.png"
                        alt="PDS Cultivation Intelligence"
                        style={{
                          maxWidth: '100%',
                          maxHeight: '400px',
                          height: 'auto',
                          width: 'auto'
                        }}
                      />
                    </Grid>
                  )}
                  
                  {/* Login Form Side */}
                  <Grid item xs={12} md={6} style={{ 
                    padding: '3rem 2rem',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center'
                  }}>
                    <LoginForm redirectUrl={redirectUrl} />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Container>
        </Box>
      </AppBarLayout>
    </>
  );
}
